import { reactive } from 'vue';

export const criarAnexo = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idoperador: 0,
        cdgrupo: 0,
        nmdoc: '',
        dtanexo: '',
        dtvalidade: '',
        obspostagem: '',
        fname: '',
        tipo: '',
        origem_sistema: 'SGOS-WEB',
        origem_versao: '1.26.0127',
        idlogin: 0
    });
}